import { isResource } from '@medplum/core'
import type { List, Reference } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class ExtendedList extends ExtendedResource<List> {
  static readonly RESOURCE_TYPE = 'List'

  static isInstance(value: unknown): value is List {
    return isResource(value) && isOfType(value, 'List')
  }

  static bySource(source: Reference): QueryTypes {
    return {
      source,
    }
  }

  constructor(
    data?: Omit<List, 'resourceType' | 'mode' | 'status'> &
      Partial<Pick<List, 'status'>>
  ) {
    super({
      status: 'current',
      mode: 'working',
      ...data,
    })
  }

  get status(): List['status'] {
    return this.resource.status
  }

  set status(status: List['status']) {
    this.resource.status = status
  }
}
